// extracted by mini-css-extract-plugin
export default {"textField":"MyInput_textField__oyFM5","input-wrapper":"MyInput_input-wrapper__uaqBz","readOnly":"MyInput_readOnly__WlM-L"};